<div class="row">
  <div class="col-12 col-md-6">
    <form [formGroup]="gdprForm">
      <div class="col-12 wrapp_form">
        <mh-core-lib-toggle
          formControlName="auto_delete_personal_data"
          [label]="'customer.configurations.hotel.gdpr.auto_deletion_label' | translate"
          [labelPosition]="'vertical'">
        </mh-core-lib-toggle>
      </div>
      <div class="col-12 wrapp_form tw-mt-4">
        <label class="tw-break-words">{{ 'customer.configurations.hotel.gdpr.retention_period_label' | translate }}</label>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-items-center tw-gap-3 tw-mt-2">
          <input type="number" class="form-control tw-w-full tw-max-w-[120px]" formControlName="deletion_days_after_checkout" />
          <span class="tw-text-gray-700 tw-whitespace-nowrap">{{ 'customer.configurations.hotel.gdpr.days_suffix' | translate }}</span>
        </div>
      </div>
    </form>
  </div>

  <div class="col-12 col-md-6 tw-flex tw-items-start md:tw-items-center tw-justify-center tw-mt-6 md:tw-mt-0 tw-px-1 md:tw-px-0">
    <div class="tw-w-full tw-max-w-md tw-min-w-0 tw-text-gray-400 tw-whitespace-pre-line tw-text-sm md:tw-text-lg tw-text-left md:tw-text-center tw-font-bold">
      <span>{{ 'customer.configurations.hotel.gdpr.info_message_lead' | translate }}</span><span class="tw-text-neutral-950">{{ 'customer.configurations.hotel.gdpr.info_message_emphasis' | translate }}</span><span>{{ 'customer.configurations.hotel.gdpr.info_message_body_tail' | translate }}</span><span>{{ 'customer.configurations.hotel.gdpr.info_message_warning' | translate }}</span>
    </div>
  </div>
</div>
